import { defineStore } from "pinia"
import { computed, ref, type Ref } from "vue"
import { AvailabilityReason } from "@/models/availability-reason.model.ts"

export const useAvailabilityReasonStore = defineStore("availabilityReasonStore", () => {
  const availabilityReasons: Ref<AvailabilityReason[]> = ref([])

  function getAvailabilityReasonsForEntityTable(entityTable: string) {
    return computed(() =>
      availabilityReasons.value.filter((reason) => reason.entityTable === entityTable)
    )
  }

  return { availabilityReasons, getAvailabilityReasonsForEntityTable }
})
